import { Link } from "react-router-dom";

function Pricing() {
  return (
    <section
      className="py-5 bg-light-lighten border-top border-bottom border-light"
      id="pricing"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center animate-on-scroll">
              <h1 className="mt-0">
                <i className="mdi mdi-tag-multiple"></i>
              </h1>
              <h2 className="fw-bold">
                Flexible <span className="text-primary">Pricing</span> Plans
              </h2>
              <p className="text-muted mt-2 lead">
                Choose the perfect plan for your sportswear business. <br />
                All plans include core features with scalable options for
                growing businesses.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-5 pt-3">
          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="card card-pricing feature-card border-0 shadow">
              <div className="card-body text-center">
                <p className="card-pricing-plan-name fw-bold text-uppercase">
                  Starter
                </p>
                <i className="card-pricing-icon mdi mdi-account text-primary"></i>
                <h2 className="card-pricing-price">Contact Us</h2>
                <ul className="card-pricing-features">
                  <li>Up to 5 Users</li>
                  <li>Basic CRM Features</li>
                  <li>Quote Management</li>
                  <li>Work Order Tracking</li>
                  <li>Email Support</li>
                  <li>Cloud Storage</li>
                </ul>
                <Link
                  to="/app/client-login"
                  className="btn btn-primary mt-4 mb-2 rounded-pill"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="card card-pricing card-pricing-recommended feature-card border-0 shadow-lg">
              <div className="card-body text-center">
                <div className="card-pricing-plan-tag">Most Popular</div>
                <p className="card-pricing-plan-name fw-bold text-uppercase">
                  Professional
                </p>
                <i className="card-pricing-icon mdi mdi-briefcase text-primary"></i>
                <h2 className="card-pricing-price">Contact Us</h2>
                <ul className="card-pricing-features">
                  <li>Up to 25 Users</li>
                  <li>Full CRM & Manufacturing</li>
                  <li>Inventory Management</li>
                  <li>Advanced Reporting</li>
                  <li>Priority Support</li>
                  <li>Multi-Location Support</li>
                </ul>
                <Link
                  to="/app/client-login"
                  className="btn btn-primary mt-4 mb-2 rounded-pill pulse-animation"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="card card-pricing feature-card border-0 shadow">
              <div className="card-body text-center">
                <p className="card-pricing-plan-name fw-bold text-uppercase">
                  Enterprise
                </p>
                <i className="card-pricing-icon mdi mdi-office-building text-primary"></i>
                <h2 className="card-pricing-price">Contact Us</h2>
                <ul className="card-pricing-features">
                  <li>Unlimited Users</li>
                  <li>Complete ERP Suite</li>
                  <li>Custom Integrations</li>
                  <li>Dedicated Support</li>
                  <li>Custom Training</li>
                  <li>SLA Guarantee</li>
                </ul>
                <Link
                  to="/app/client-login"
                  className="btn btn-primary mt-4 mb-2 rounded-pill"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
